export enum WorkflowSteps {
    Basic = 1,
    Stages = 2,
    States = 3,
    Actions = 4,
    Transitions = 5,
}

export type WFError = {
    message: string;
    indices: number[];
};

export type WorkflowStructureValidationError = {
    message: string;
    step: WorkflowSteps;
    indices?: number[];
};

export type ExpandTrigger = { step: WorkflowSteps; id: number; formId?: number | null } | undefined;

export type WorkflowEditorInitialExpand = {
    step: WorkflowSteps;
    formId?: number | null;
    actionId?: number;
};
